import Model from './Model'

export default class DeliveryModel extends Model {
  id!: number

  resource () : string {
    return 'deliveries'
  }
}
